import { InspectPinMode, Map as MainMap, MapLayer } from '@/map'

export function Map() {
  return (
    <MainMap selectionContext="none" mapId="ww-map">
      <InspectPinMode mode="none" />
      <MapLayer uid="order" />
      <MapLayer uid="depot" />
      <MapLayer uid="region" />
      <MapLayer uid="roadSegment" />
      <MapLayer uid="geofence" visible={false} />
      <MapLayer uid="routePolyline" />
      <MapLayer uid="place" />
      <MapLayer uid="device" />
      <MapLayer uid="vehicle" />
    </MainMap>
  )
}
